<template>
  <div class="textblock-with-headline">
    <div class="font-bold">
      {{ title }}
    </div>
    <div
      v-for="line in lines"
      :key="line">
      {{ line }}
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: {
      lines: {
        default: () => [],
        type: Array,
      },
      title: {
        default: ``,
        type: String,
      },
    },
  };
</script>

<style lang="less" scoped>
  .textblock-with-headline {
    margin-bottom: 2rem;
  }
</style>
